import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/*
meta {
    title: String, // document.title 和 NavBar组件的标题
    name: String, // tabbar组件匹配当前激活的页面name
    cache: Boolean, // 是否被keep-alive组件缓存
}
*/
// TODO 自行删除不必要代码
const routes = [
    { path: '/', redirect: { name: 'home' }, },
    // {/* 首页 */path: '/', name: 'home', component: () => import('../views/home/home.vue'), meta: { title: "首页", name: "home", } },
    {/* 首页 */path: '/home', name: 'home', component: () => import('../views/home'), meta: { title: "首页", name: "home", } },
    {/* 门店 */path: '/shop', name: 'shop', component: () => import('../views/shop'), meta: { title: "门店", name: "shop", } },
    {/* 保养视频 */path: '/maintainVideo', name: 'maintainVideo', component: () => import('../views/maintainVideo'), meta: { title: "保养视频", name: "maintainVideo", } },
    {/* 随心所欲 */path: '/particulars', name: 'particulars', component: () => import('../views/particulars'), meta: { title: "随心所欲", name: "particulars", } },
    {/* 无极动态 */path: '/dynamic', name: 'dynamic', component: () => import('../views/dynamic'), meta: { title: "无极动态", name: "dynamic", } },
    {/* 服务反馈 */path: '/feedback', name: 'feedback', component: () => import('../views/feedback'), meta: { title: "服务反馈", name: "feedback", } },
    {/* 产品世界 */path: '/productCenter', name: 'productCenter', component: () => import('../views/productCenter/productCenter.vue'), meta: { title: "产品世界", name: "productCenter", } },
    {/* 保养指南 */path: '/maintain', name: 'maintain', component: () => import('../views/maintain'), meta: { title: "保养指南", name: "maintain", } },
    {/* 保修范围 */path: '/warranty', name: 'warranty', component: () => import('../views/warranty/'), meta: { title: "保修范围", name: "warranty", } },
    {/* 招商 */path: '/attractInvestment', name: 'attractInvestment', component: () => import('../views/attractInvestment'), meta: { title: "招商", name: "attractInvestment", } },
    {/* 品牌文化 */path: '/brandCulture', name: 'brandCulture', component: () => import('../views/brandCulture/brandCulture.vue'), meta: { title: "品牌文化", name: "brandCulture", } },
    {/* 预约试驾 */path: '/subscribe', name: 'subscribe', component: () => import('../views/subscribe/subscribe.vue'), meta: { title: "预约试驾", name: "subscribe", } },
    {/* 匠心故事 */path: '/originalityStory', name: 'originalityStory', component: () => import('../views/originalityStory/originalityStory.vue'), meta: { title: "匠心故事", name: "originalityStory", } },
    {/* 最新活动 */path: '/latestActivity', name: 'latestActivity', component: () => import('../views/latestActivity/index.vue'), meta: { title: "最新活动", name: "latestActivity", } },
    {/* 媒体测评 */path: '/evaluation', name: 'evaluation', component: () => import('../views/evaluation/index.vue'), meta: { title: "媒体测评", name: "evaluation", } },
    {/* 摩旅服务 */path: '/travelService', name: 'travelService', component: () => import('../views/travelService/travelService.vue'), meta: { title: "摩旅服务", name: "travelService", } },
    {/* 列表详情 */path: '/dynamicDetail', name: 'dynamicDetail', component: () => import('../views/dynamicDetail/index.vue'), meta: { title: "列表详情", name: "dynamicDetail", } },
]

const router = new VueRouter({
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

/* 全局前置守卫 */
// router.beforeEach((to, from, next) => {
//     /*路由发生改变修改页面的title */
//     if (to.meta.title) {
//         document.title = to.meta.title
//     } else {
//         document.title = ""
//     }
//     next()
// })
// /* 全局后置钩子 */
// router.afterEach((to, from) => {
//     console.log("全局后置钩子", from)
// })

export default router
